export default defineNuxtRouteMiddleware(async (to) => {
  // Only check location routes
  if (!to.path.includes('/brisbane') && !to.path.includes('/gold-coast') && !to.path.includes('/sydney')) {
    return
  }

  try {
    // Extract location slug from path
    const pathParts = to.path.split('/')
    const locationSlug = pathParts[1] // e.g., 'brisbane', 'gold-coast', 'sydney'

    // Import the location data with error handling
    const { getLocationData } = await import('~/config/locations')
    const location = getLocationData(locationSlug)

    // If location doesn't exist or is disabled, return 404
    if (!location || !location.enabled) {
      throw createError({ statusCode: 404, statusMessage: 'Location not found' })
    }
  } catch (error) {
    // Log error for debugging but don't expose it to users
    console.error('Location guard error:', error)
    throw createError({ statusCode: 404, statusMessage: 'Location not found' })
  }
}) 